import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { HTTP_ERROR_CONTEXT, HttpErrorConfig } from './http-error-context.config';
import { SweetAlertResult } from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    @BlockUI() blockUI: NgBlockUI;

    constructor(
        private readonly notiService: ProcesosComunesComplementoService,
        private readonly authService: AuthService,
        private readonly dialog: MatDialog,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const config = req.context.get(HTTP_ERROR_CONTEXT);
        if (!config || ['global'].includes(config.modulo)) {
            return next.handle(req);
        }
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                this.dialog.closeAll();
                this.blockUI.stop();
                return this.handleErrorByModule(error, config);
            })
        );
    }

    private handleErrorByModule(error: HttpErrorResponse, config: any): Observable<HttpEvent<any>> {
        if (['perdida-total'].includes(config.modulo)) this.handleMessageErrorPT(error, config);
        return throwError(() => error);
    }

    private handleMessageErrorPT(error: HttpErrorResponse, config: any): void {
        const codigoRespuesta = error?.error?.header?.codigoRespuesta;
        const mensajeRespuesta = error?.error?.header?.descripcionRespuesta;
        const listaErrores = this.obtenerListaErroresHtml(error?.error?.header?.razonesFalla || error?.error?.headerResponse?.reasons?.reason);
        switch (error.status) {
            case 0:
                if (!config.manejarStatus0) return;
                this.generateAlert(config, 'Tuvimos un problema procesando tu solicitud <br> Inténtalo de nuevo en unos minutos.', 'Aviso', 'warning');
                break;
            case 401:
                if (config.cerrarSesion401) {
                    this.generateAlert(config, `
                    ${mensajeRespuesta || 'Tu sesión ha expirado. Inicia sesión nuevamente para continuar.'} <br>
                    Si crees que esto es un error, contacta soporte e indica el código: <b>${codigoRespuesta}</b>
                    `, 'Error', 'error').then((result: SweetAlertResult) => {
                        this.authService.limpiarTokens(true, null, true);
                    });

                }
                break;
            case 400:
                if (!config.manejar400) return;
                this.generateAlert(config, `
                    ${mensajeRespuesta || 'Tuvimos un problema procesando tu solicitud.'} <br>
                    Si crees que esto es un error, contacta soporte e indica el código: <b>${codigoRespuesta}</b>
                    <br>
                    ${listaErrores}
                    `
                    , 'Aviso', 'warning');
                break;
            default:
                if (error.status >= 500 && config.manejar500) {
                    this.generateAlert(config, `
                    ${mensajeRespuesta || 'Tuvimos un problema procesando tu solicitud. Inténtalo de nuevo en unos minutos.'} <br>
                    Si el problema continúa, contacta soporte e indica el código: <b>${codigoRespuesta}</b>
                `, 'Error', 'error')
                }
                break;
        }
    }

    private obtenerListaErroresHtml(listaErrores: any[]): string {
        if (!listaErrores || listaErrores.length === 0) return '';
        return ` <br><br>
        <ul style="text-align:left; padding-left:20px;">
        ${listaErrores.map(err => `<li>${err?.descripcion || err?.description}</li>`).join('')}
        </ul>`;
    }

    private generateAlert(config: HttpErrorConfig, mensaje: string, titulo: string, tipo: 'error' | 'warning' | 'info'): Promise<SweetAlertResult<any>> {
        if (!config.mostrarNotificacion) return;

        const html = `
      <div style="text-align:center;">
        ${mensaje}
      </div>`;

        return this.notiService.alertaGeneralComplemento(titulo, '', tipo, false, true, html, "INICIAR SESIÓN");
    }
}